<div class="bg-white overflow-hidden shadow sm:rounded-lg">
  <div class="">
    <!-- Header -->
    <div class="border-b border-b-gray-300 zuper-dialog-header">
      <div class="flex justify-between">
        <h6 mat-dialog-title class="font-semibold primary-font">{{'recurring.jobs_view.header.text' | translate}}</h6>
        <badge *ngIf="getRecurringJobsCount('ALL')" class="ml-2" [options]="getRecurringJobsCountBadge('ALL')"></badge>
      </div>
      <div class="flex items-center ml-auto">
        <span mat-dialog-close
          class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
          <em class="ti ti-x text-xl font-bold"></em>
        </span>
      </div>
    </div>
    <!-- Body -->
    <div class="view-all-recurring-jobs-body-container pb-4">
      <div class="flex flex-col w-full">
        <div class="flex border-b w-full">
          <nav class="-mb-px flex space-x-8 w-full h-15" aria-label="Tabs">
            <a *ngFor="let tab of tabs"
              class="whitespace-nowrap flex w-1/2 flex items-center justify-center py-4 px-1 border-b-2 font-medium text-base cursor-pointer"
              (click)="changeViewMode(tab.dataKey)" [ngClass]="{
                      'border-indigo-500 text-indigo-600': viewMode === tab.dataKey,
                      'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': viewMode !== tab.dataKey
                    }">
              {{tab.displayKey | translate}}
              <badge class="ml-2" [options]="getRecurringJobsCountBadge(tab.dataKey)"></badge>
            </a>
          </nav>
        </div>
        <div class="flex h-18 items-center my-1">
          <!-- Search Field -->
          <mat-form-field class="w-1/3 pl-6" appearance="fill">
            <em class="ti ti-search" matPrefix></em>
            <input type="text" matInput placeholder="{{'text.search_jobs.placeholder' | translate}}"
              [(ngModel)]="searchKey" (keyup.enter)="triggerSearch(searchKey)">
            <em class="ti ti-x close-mark cursor-pointer" *ngIf="searchKey.length"
              (click)="searchKey='';triggerSearch(searchKey)" matSuffix></em>
          </mat-form-field>
          <!-- Pagination -->
          <mat-paginator class="recurrence-jobs-paginate h-18 ml-auto" [length]="pagination.totalRecords"
            [pageSize]="pagination.pageSize" [pageIndex]="pagination.pageIndex" [hidePageSize]="true"
            (page)="onPageEvent($event)">
          </mat-paginator>
        </div>
        <div class="h-1 mx-6">
          <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div class="view-all-recurring-jobs-content-container">
          <div
            class="flex flex-col flex-auto view-all-recurring-jobs-table-container overflow-auto mx-6 mb-4 border-l border-r hover-stripped zuper-scrollbar"
            *ngIf="jobsList.length">
            <table mat-table [dataSource]="jobsList" class="view-all-recurring-jobs-table" aria-describedby="Jobs">
              <!-- Job No Column -->
              <ng-container matColumnDef="JOB_NO">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="pr-2">
                    {{'text.job_no' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="pr-2">
                    <a class="font-medium cursor-pointer hover:text-blue-500 hover:underline" target="_blank"
                      *ngIf="!element?.is_deleted" [routerLink]="utilityService.getLink('JOB', element?.job_uid)">
                      {{element?.prefix ?? ''}}{{element?.work_order_number ?? ''}}
                    </a>
                    <span *ngIf="element?.is_deleted">
                      {{element?.prefix ?? ''}}{{element?.work_order_number ?? ''}}
                    </span>
                  </div>
                </td>
              </ng-container>
              <!-- Job Title Column -->
              <ng-container matColumnDef="JOB_TITLE">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="px-2">
                    {{'text.job_title' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="px-2">
                    <a class="font-medium cursor-pointer hover:text-blue-500 hover:underline" target="_blank"
                      *ngIf="!element?.is_deleted" [routerLink]="utilityService.getLink('JOB', element?.job_uid)">
                      {{element?.job_title ?? ''}}
                    </a>
                    <span *ngIf="element?.is_deleted">
                      {{element?.job_title ?? ''}}
                    </span>
                  </div>
                </td>
              </ng-container>
              <!-- Client Column -->
              <ng-container matColumnDef="CLIENT">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="px-2">
                    {{'text.client' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="px-2">
                    <ng-container *ngIf="element?.customer">
                      <a class="font-medium cursor-pointer hover:text-blue-500 hover:underline" target="_blank"
                        *ngIf="!element?.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar')"
                        [routerLink]="utilityService.getLink('CUSTOMER', element?.customer?.customer_uid)">
                        {{element?.customer?.customer_first_name ?? ''}} {{element?.customer?.customer_last_name ?? ''}}
                      </a>
                      <span *ngIf="element?.customer?.is_deleted || !utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar')">
                        {{element?.customer?.customer_first_name ?? ''}} {{element?.customer?.customer_last_name ?? ''}}
                      </span>
                    </ng-container>
                    <ng-container *ngIf="!element?.customer && element?.organization">
                      <a class="font-medium cursor-pointer hover:text-blue-500 hover:underline" target="_blank"
                        *ngIf="!element?.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')"
                        [routerLink]="utilityService.getLink('ORGANIZATION', element?.organization?.organization_uid)">
                        {{element?.organization?.organization_name ?? ''}}
                      </a>
                      <span *ngIf="element?.organization?.is_deleted || !utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')">
                        {{element?.organization?.organization_name ?? ''}}
                      </span>
                    </ng-container>
                  </div>
                </td>
              </ng-container>
              <!-- Category Column -->
              <ng-container matColumnDef="CATEGORY">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="px-2">
                    {{'category.text' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="px-2">
                    {{element?.job_category?.category_name ?? ''}}
                  </div>
                </td>
              </ng-container>
              <!-- Status Column -->
              <ng-container matColumnDef="STATUS">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="px-2">
                    {{'status.text' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="px-2">
                    <badge *ngIf="element?.job_status?.length"
                      [options]="getJobStatusBadge(element?.job_status[element?.job_status?.length - 1])"></badge>
                  </div>
                </td>
              </ng-container>
              <!-- Priority Column -->
              <ng-container matColumnDef="PRIORITY">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="px-2">
                    {{'text.priority' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="px-2">
                    <badge *ngIf="element?.job_priority" [options]="getBadgeOptions(element?.job_priority)"></badge>
                  </div>
                </td>
              </ng-container>
              <!-- Scheduled Date Column -->
              <ng-container matColumnDef="SCHEDULED_DATE">
                <th mat-header-cell *matHeaderCellDef
                  class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                  <div class="pl-2">
                    {{'text.scheduled_date' | translate}}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-base">
                  <div class="pl-2">
                    <ng-container *ngIf="element?.scheduled_start_time && element?.scheduled_end_time">
                      {{element?.scheduled_start_time | datetime : utilityService.dateTimeFormat : preferredTimeZone}} -> {{element?.scheduled_end_time | datetime : utilityService.dateTimeFormat :preferredTimeZone: !!(timezone)}}
                    </ng-container>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;" class="bg-gray-50"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <div class="h-80 mb-4 flex flex-col items-center justify-center" *ngIf="!jobsList.length && !isLoading">
            <div class="flex flex-col items-center justify-center">
              <img class="w-40 m-auto" src="assets/images/svgs/no_activity_found.svg" alt="No Jobs Found">
              <h4 class="font-medium mt-4 text-secondary">{{'recurring.jobs_view.placeholder.not_found' |
                translate}}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div mat-dialog-actions class="flex justify-end border-t border-gray-300 mb-0 px-6">
      <div class="flex justify-around">
        <button type="button" mat-dialog-close
          class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
          {{'close.text' | translate}}</button>
      </div>
    </div>
  </div>
</div>